import app from '../../../app';

export const IdentityBrokerConfig = Object.freeze({
    oauthClientDomain: app.state.ssoConfig.identityBrokerConfig.oauthClientDomain,
    headerRegisterRoute: app.state.ssoConfig.identityBrokerConfig.headerRegisterRoute,
    ticketingRegisterRoute: app.state.ssoConfig.identityBrokerConfig.ticketingRegisterRoute,
    updateAccountRoute: app.state.ssoConfig.identityBrokerConfig.updateAccountRoute,
    upgradeToOneClubAdvantageRoute: app.state.ssoConfig.identityBrokerConfig.upgradeToOneClubAdvantageRoute,
    upgradeToTicketingRoute: app.state.ssoConfig.identityBrokerConfig.upgradeToTicketingRoute,
    forgotPasswordRoute: app.state.ssoConfig.identityBrokerConfig.forgotPasswordRoute,
    changePasswordRoute: app.state.ssoConfig.identityBrokerConfig.changePasswordRoute,
});
